<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  name: "app",
  components: {},
  data: () => ({}),
  watch: {
    "$store.state.theme"(val) {
      this.toggleBodyClass(val);
    },
  },
  methods: {
    toggleBodyClass(className) {
      if (className == "dark") {
        document.body.classList.add("dark-theme");
      } else {
        document.body.classList.remove("dark-theme");
      }
    },
  },

  mounted() {
    this.toggleBodyClass(themeConfig.theme);
  },
};
</script>
<style>

@font-face {
  font-family: "Digital Numbers";
  src: url(https://www.fontmirror.com/app_public/files/t/1/DigitalNumbers-Regular_50ec4c0e60a39023c2560d3fcdb8a9cf.ttf)
    format("truetype");
}

@font-face {
  font-family: "BaiJamjuree";
  src: local("BaiJamjuree"),
   url(./assets/fonts/BaiJamjuree-Medium.ttf) format("truetype");
}
</style>